/* eslint-disable import/order */
import { MenuIdAddons } from '@jira/navigation-apps__constants/src/MenuIdAddons.tsx';
import { LazyAtlassianNavigation } from '@jira/navigation-apps__atlassian-navigation/src/async.tsx';
import { createEntry } from '@jira/platform__routing-route-entry/src/createEntry.tsx';
import { createLayout } from '@jira/platform__layouts-route-layout/src/GlobalComponent.tsx';
import { getServiceDeskNavigationSingleResources } from '@jira/router-resources__service-desk-common/src/getServiceDeskSettingsResources.tsx';
import { connectGeneralServiceDeskProjectRoute } from '@jira/router-routes__connect-routes/src/connectGeneralServiceDeskProjectRoute.tsx';
import type { Route, RouteContext } from '@atlassian/react-resource-router';
import { getGeneralConnectRouteResources } from './common/index.tsx';
import ConnectGeneralPage, { LazyGeneralConnect } from './ui/spa/connect/general/index.tsx';

export const connectGeneralServiceDeskProjectRouteEntry: Route = createEntry(
	connectGeneralServiceDeskProjectRoute,
	() => ({
		group: 'connect',
		layout: createLayout(),

		navigation: {
			menuId: MenuIdAddons,
		},

		// eslint-disable-next-line no-restricted-syntax
		component: ConnectGeneralPage,
		resources: [...getGeneralConnectRouteResources(), ...getServiceDeskNavigationSingleResources()],

		canTransitionIn: (current: RouteContext, next: RouteContext) => {
			const { query } = next.match;

			// must be in sync with com.atlassian.jira.web.filters.frontend.ConnectGeneralPagesFrontendRoute::matchesRequest
			// block transitions to mobile version
			if (
				query.mobile === 'true' ||
				query.includeWebResources === 'true' ||
				query.classifier === 'json'
			) {
				return false;
			}

			// block transitions to marketplace app as it requires specialised Connect API -
			const emceeKeyRegex =
				/com\.atlassian\.(jira|confluence)\.emcee($|\.local|\.staging|\.development\..*)/g;
			const addonKey = next.match.params.addonKey || '';
			if (emceeKeyRegex.test(addonKey)) {
				return false;
			}
			return true;
		},

		forPaint: [LazyAtlassianNavigation, LazyGeneralConnect],
		ufoName: 'jira-connect',

		bifrost: {
			bifrostGroup: 'shell-only',
		},
	}),
);
